import { EditorState, Modifier, SelectionState } from "draft-js";

const removeBlockRange = (editorState, {
    anchorKey,
    anchorOffset,
    focusKey,
    focusOffset,
    direction,
}) => {
    const content = editorState.getCurrentContent();
    const removeSelection = SelectionState.createEmpty(anchorKey).merge({
        anchorKey,
        anchorOffset,
        focusKey,
        focusOffset,
        hasFocus: true,
    });

    const newContent = Modifier.removeRange(content, removeSelection, direction);
    const nextState = EditorState.push(editorState, newContent, "remove-range");

    return EditorState.forceSelection(nextState, newContent.getSelectionAfter());
};

export const shouldHandleAtomicBackspace = (editorState) => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) return false;

    const content = editorState.getCurrentContent();
    const currentKey = selection.getStartKey();
    const currentBlock = content.getBlockForKey(currentKey);
    const currentOffset = selection.getStartOffset();

    if (currentOffset === 0) {
        const prevBlock = content.getBlockBefore(currentKey);
        return !!prevBlock && prevBlock.getType() === "atomic";
    }

    if (currentOffset === currentBlock.getLength()) {
        const nextBlock = content.getBlockAfter(currentKey);
        return !!nextBlock && nextBlock.getType() === "atomic";
    }

    return false;
};

export const shouldHandleAtomicDelete = (editorState) => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) return false;

    const content = editorState.getCurrentContent();
    const currentKey = selection.getStartKey();
    const currentBlock = content.getBlockForKey(currentKey);
    const currentOffset = selection.getStartOffset();

    if (currentOffset !== currentBlock.getLength()) return false;

    const nextBlock = content.getBlockAfter(currentKey);
    return !!nextBlock && nextBlock.getType() === "atomic";
};

export const removeAtomicByBackspace = (editorState) => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) return null;

    const content = editorState.getCurrentContent();
    const currentKey = selection.getStartKey();
    const currentBlock = content.getBlockForKey(currentKey);
    const currentOffset = selection.getStartOffset();

    if (currentOffset === 0) {
        const prevBlock = content.getBlockBefore(currentKey);
        if (!prevBlock || prevBlock.getType() !== "atomic") return null;

        return removeBlockRange(editorState, {
            anchorKey: prevBlock.getKey(),
            anchorOffset: 0,
            focusKey: currentKey,
            focusOffset: 0,
            direction: "backward",
        });
    }

    if (currentOffset === currentBlock.getLength()) {
        const nextBlock = content.getBlockAfter(currentKey);
        if (!nextBlock || nextBlock.getType() !== "atomic") return null;

        return removeBlockRange(editorState, {
            anchorKey: currentKey,
            anchorOffset: currentOffset,
            focusKey: nextBlock.getKey(),
            focusOffset: nextBlock.getLength(),
            direction: "forward",
        });
    }

    return null;
};

export const removeAtomicByDelete = (editorState) => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) return null;

    const content = editorState.getCurrentContent();
    const currentKey = selection.getStartKey();
    const currentBlock = content.getBlockForKey(currentKey);
    const currentOffset = selection.getStartOffset();

    if (currentOffset !== currentBlock.getLength()) return null;

    const nextBlock = content.getBlockAfter(currentKey);
    if (!nextBlock || nextBlock.getType() !== "atomic") return null;

    return removeBlockRange(editorState, {
        anchorKey: currentKey,
        anchorOffset: currentOffset,
        focusKey: nextBlock.getKey(),
        focusOffset: nextBlock.getLength(),
        direction: "forward",
    });
};
